import { render, staticRenderFns } from "./ExecutedTrades.vue?vue&type=template&id=1004f450&"
import script from "./ExecutedTrades.vue?vue&type=script&lang=js&"
export * from "./ExecutedTrades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports